import styled from 'styled-components'

interface Props {
  selected?: boolean
}

export const SelectableListItem = styled.div<Props>`
  background-color: ${({ selected }) => (selected ? 'gray' : '')};
`
